import React from 'react'
import LiveWorkspace from '../components/Main/Live/LiveWorkspace'

const LivePage = () => (
  <div className="w-full flex-1 flex flex-col relative min-h-[calc(100vh-80px)]">
    <LiveWorkspace />
  </div>
)

export default LivePage
